import ClientsBaseController from 'webapp/controllers/clients/base';

export default class ClientsGoalsController extends ClientsBaseController {
	override trackingOrigin = 'client_kpis';
}
